import { useParams } from 'next/navigation'
import {
  bigDataNumFloat,
  bigNumberTimes,
  createBigDataNumFloatByMoreSet,
  createGetContractDeliverTypeText,
  formatMoney,
  rateFilter,
} from './index'
import { TLanguages } from '../config/locale'
import { useExchangeRate } from '@/components/appStore'
import { useLocale } from '../components/Locale'
import { useGetCurrencyListQuery } from '../query/yapi/hk-web/Hotcoin/query'
import { useGetV3GetOneTradeInfoQuery } from 'core/query/yapi/hk-web/TradeWsApi/query'
import { useTradeCurrentSymbol } from 'core/controller/trade/tradeStore'
import { useContractCurrentSymbol, useContractDigit } from 'core/controller/contract/contractStore'

// 后续替换掉该实现
function getModuleName() {
  let moduleName = 'contractModule'
  if (window.location.pathname.indexOf('/simulation/') > -1) {
    moduleName = 'simulationModule'
  }
  return moduleName
}

const useUtils = () => {
  const params = useParams<{
    lang: TLanguages
  }>()
  const exchangeRate = useExchangeRate()

  const t = useLocale()

  const lang = params?.lang || 'en_US'
  return {
    bigDataNumFloat: bigDataNumFloat(lang),
    rateFilter: rateFilter({ exchangeRate, lang: lang }),
    getContractTypeDisplay: createGetContractDeliverTypeText(t),
    bigDataNumFloatByMoreSet: createBigDataNumFloatByMoreSet(lang),
  }
}

export const useTradeUnit = () => {
  const { bigDataNumFloatByMoreSet } = useUtils()
  return {
    toAmount: (value?: string | number, digit: string | number) => {
      if (!digit || !value) return '-'
      return bigDataNumFloatByMoreSet({
        num: value,
        decimal: 2,
        isTransformThousands: true,
        isAddZero: true,
        noFormatDecimal: Number(digit),
      })
    },
  }
}

type ToCurrencyOptions = {
  isTrillion?: boolean
  currency?: string
}
// isTrillion: true, 434962079474.94 (rmb) => 3.17万亿 (usd)
// isTrillion: false, 434962079474.94 (rmb) => 3,171,397,253,716 (usd)
export const useToCurrency = () => {
  const { data: currencyList } = useGetCurrencyListQuery()
  const { rateFilter, bigDataNumFloatByMoreSet } = useUtils()

  const toCurrency = (value: string | undefined, options?: ToCurrencyOptions) => {
    if (value === undefined) return '-'
    const isTrillion = options?.isTrillion
    const targetCurrency = options?.currency || 'USD'
    const currency = currencyList?.data.data.find((item) => item.currencyCode === targetCurrency)
    const newValue = rateFilter(bigNumberTimes(value, currency?.exchangeRate), '')
    return isTrillion
      ? bigDataNumFloatByMoreSet({
          num: newValue,
          decimal: 2,
          isTransformThousands: true,
          isAddZero: true,
        })
      : formatMoney(Number(newValue))
  }
  return toCurrency
}

export default useUtils
